<template>
  <div class="main-section">
    <div class="filter-wrapper">
      <el-card class="header-card">
        <span
          class="unreadFilter"
          :class="{'active' : isUnreadfilter}"
          @click="isUnreadfilter = !isUnreadfilter"
        >Show Unread Only ( {{ unreadLeadNo}} )</span>
      </el-card>
      <el-card class="header-card">
        <div class="datepicker">
          <h4 class="dpheader">Start:</h4>
          <kendo-datepicker id="start" v-on:change="startChange"></kendo-datepicker>
        </div>

        <div class="datepicker">
          <h4 class="dpheader">End:</h4>
          <kendo-datepicker id="end" v-on:change="endChange"></kendo-datepicker>
        </div>

        <span @click="getConvoListbyDate" class="datepickerbuttons">Submit</span>
        <span @click="refreshConvoListApi(1)" class="datepickerbuttons">Clear</span>
      </el-card>
    </div>

    <!-- eo filter wrapper -->
    <div class="chatbox">
      <div class="chatbox-content">
        <div class="contact-box">
          <el-card class="card-left-chatbox">
            <div class="left-chatbox-header">
              <div>
                <div class="header-content">
                  <p>Lead List</p>
                </div>
              </div>
            </div>
            <!-- eo left chatbox header -->

            <!-- <div v-if="loadingChatUsers == false" class="loading">
              <div class="contact-table table-responsive">
                <table class="table list-table spacing-tale del-table">
                  <tbody class="custom-table">
                    <template>
                      <tr
                        class
                        v-for="allConvoList in convoList"
                        :data-id="allConvoList.convo_id"
                        :key="allConvoList.convo_id"
                      >
                        <td class="contact-detail">{{ allConvoList.name }}</td>
                        <td>{{ allConvoList.datetime }}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>-->

            <div class="chatbox-persons">
              <div v-if="loadingChatUsers == true" class="loading">
                <img src="~styles/img/load.gif" alt />
              </div>

              <ul
                v-if="loadingChatUsers == false && isUnreadfilter == 0"
                class="person-chat-details"
              >
                <!-- <img src="~styles/img/user.png" alt="logo"> -->

                <li
                  :class="getUnreadStatus(allConvoList.unread)"
                  class="person-details"
                  v-for="allConvoList in convoList"
                  :key="allConvoList.id"
                >
                  <a
                    v-if="allConvoList.name === null"
                    class="person-name"
                    :data-id="allConvoList.convo_id"
                    @click="changeChatUser(allConvoList.convo_id)"
                    :class="{ active: active_el == allConvoList.convo_id }"
                  >
                    <!-- <span class="span-flex span-image">
                      <img
                        :data-id="allConvoList.convo_id"
                        class="user-image"
                        src="~styles/img/user.jpg"
                        alt
                      />
                    </span>-->
                    <span class="span-flex">{{ allConvoList.convo_id }}</span>
                  </a>

                  <a
                    v-else
                    class="person-name span-flex"
                    :data-id="allConvoList.convo_id"
                    @click="changeChatUser(allConvoList.convo_id)"
                    :class="{ active: active_el == allConvoList.convo_id }"
                  >
                    <!-- <span class="span-flex span-image">
                      <img
                        :data-id="allConvoList.convo_id"
                        class="user-image"
                        src="~styles/img/user.jpg"
                        alt
                      />
                    </span>-->
                    <span class="span-flex">{{ allConvoList.name }}</span>
                    <span
                      :data-id="allConvoList.convo_id"
                      class="span-flex"
                    >{{ allConvoList.convo_id }}</span>
                    <span
                      class="date-time time-display span-flex icon-padding"
                    >{{allConvoList.datetime | date}}</span>
                  </a>

                  <div class="contact-buttons">
                    <div class="box">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Add/Edit Contact"
                        placement="top"
                      >
                        <a
                          :data-id="allConvoList.user_id"
                          @click="editcontactdetailsbtn()"
                          class="add-detail el-icon-circle-plus-outline icon-padding"
                        ></a>
                      </el-tooltip>
                    </div>
                  </div>

                  <div
                    class="unread-btn-wrapper"
                    v-if="getUnreadStatus(allConvoList.unread) == 'unread'"
                  >
                    <div class="box">
                      <el-tooltip class="item" effect="dark" content="Mark As Read" placement="top">
                        <a
                          :data-id="allConvoList.user_id"
                          @click="markAsRead(allConvoList.convo_id)"
                          class="add-detail el-icon-check icon-padding"
                        ></a>
                      </el-tooltip>
                    </div>
                  </div>
                  <!-- unread-btn-wrapper -->
                  <!-- eo red btn holder -->
                </li>
              </ul>

              <!-- Logic for Unread Filter -->
              <ul
                v-if="loadingChatUsers == false && isUnreadfilter == 1 "
                class="person-chat-details"
              >
                <!-- <img src="~styles/img/user.png" alt="logo"> -->

                <li
                  :class="getUnreadStatus(allConvoList.unread)"
                  class="person-details"
                  v-for="allConvoList in convoList"
                  :key="allConvoList.id"
                  v-if="getUnreadStatus(allConvoList.unread) == 'unread'"
                >
                  <a
                    v-if="allConvoList.name === null"
                    class="person-name"
                    :data-id="allConvoList.convo_id"
                    @click="changeChatUser(allConvoList.convo_id)"
                    :class="{ active: active_el == allConvoList.convo_id }"
                  >
                    <!-- <span class="span-flex span-image">
                      <img
                        :data-id="allConvoList.convo_id"
                        class="user-image"
                        src="~styles/img/user.jpg"
                        alt
                      />
                    </span>-->
                    <span class="span-flex">{{ allConvoList.convo_id }}</span>
                  </a>

                  <a
                    v-else
                    class="person-name span-flex"
                    :data-id="allConvoList.convo_id"
                    @click="changeChatUser(allConvoList.convo_id)"
                    :class="{ active: active_el == allConvoList.convo_id }"
                  >
                    <!-- <span class="span-flex span-image">
                      <img
                        :data-id="allConvoList.convo_id"
                        class="user-image"
                        src="~styles/img/user.jpg"
                        alt
                      />
                    </span>-->
                    <span class="span-flex">{{ allConvoList.name }}</span>
                    <span
                      :data-id="allConvoList.convo_id"
                      class="span-flex"
                    >{{ allConvoList.convo_id }}</span>
                    <span class="date-time time-display span-flex">{{allConvoList.datetime | date}}</span>
                  </a>

                  <div class="contact-buttons">
                    <div class="box">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Add/Edit Contact"
                        placement="top"
                      >
                        <a
                          :data-id="allConvoList.user_id"
                          @click="editcontactdetailsbtn()"
                          class="add-detail el-icon-circle-plus-outline"
                        ></a>
                      </el-tooltip>
                    </div>
                  </div>

                  <div
                    class="unread-btn-wrapper"
                    v-if="getUnreadStatus(allConvoList.unread) == 'unread'"
                  >
                    <div class="box">
                      <el-tooltip class="item" effect="dark" content="Mark As Read" placement="top">
                        <a
                          :data-id="allConvoList.user_id"
                          @click="markAsRead(allConvoList.convo_id)"
                          class="add-detail el-icon-check"
                        ></a>
                      </el-tooltip>
                    </div>
                  </div>
                  <!-- unread-btn-wrapper -->
                  <!-- eo red btn holder -->
                </li>
              </ul>
            </div>
            <!-- eo chatbox-persons -->
          </el-card>
        </div>
        <!-- eo left select chat -->
      </div>
      <!-- eo chatbox content -->

      <div class="paginationbutton" v-if="loadingChatUsers == false">
        <el-card class="Next Page">
          <span v-if="currentPage>1" class="nextPage el-icon-arrow-left" @click="prevPage();"></span>

          <span>Page {{currentPage}} of {{totalPages}}</span>
          <span
            v-if="currentPage<=totalPages-1"
            class="nextPage el-icon-arrow-right"
            @click="nextPage()"
          ></span>
        </el-card>
      </div>
      <!-- eo paginationbutton -->
    </div>
    <!-- eo chat box -->

    <!-- dialog for new chat -->
    <el-dialog title="Send message" :visible.sync="addNewChat" width="50%">
      <form class="content-form">
        <div class="form-group">
          <label for>Number:</label>
          <input type="number" class="form-control" id v-model="newChatNumber" />
        </div>
        <div class="form-group">
          <label for>Message:</label>
          <textarea
            class="form-control message-text"
            rows="3"
            id="comment"
            v-model="newChatMessage"
            :maxlength="600"
            :minlength="10"
          ></textarea>
        </div>
      </form>

      <span slot="footer" class="dialog-footer" left>
        <el-button @click="addNewChat = false">Cancel</el-button>
        <el-button type="primary" @click="createNewChat()">Send</el-button>
      </span>
    </el-dialog>

    <!-- dialog for editing contact -->
    <el-dialog title="Edit Contact" :visible.sync="editContactdetails" width="50%">
      <div v-if="loadingEditContacts == true" class="loading">
        <img src="~styles/img/load.gif" alt />
      </div>

      <form v-if="loadingEditContacts == false" class="content-form">
        <div class="form-group">
          <label for>Name:</label>
          <input type="text" class="form-control" v-model="editContact.name" autofocus />
        </div>

        <div class="form-group">
          <label for>
            Number:
            <span class="text-info">(Please use country code)</span>
          </label>
          <input
            type="number"
            class="form-control"
            :minlength="10"
            :maxlength="14"
            v-model="editContact.number"
          />
        </div>

        <div class="form-group">
          <label for>code:</label>
          <input type="text" class="form-control" v-model="editContact.code" autofocus />
        </div>

        <div class="form-group">
          <label for>Age:</label>
          <input type="number" class="form-control" :maxlength="3" v-model="editContact.age" />
        </div>

        <div class="form-group">
          <label for>Gender:</label>
          <select class="form-control" v-model="editContact.gender">
            <option value>Select Gender</option>
            <option value="M">Male</option>
            <option value="F">Female</option>
            <option value="O">Other</option>
          </select>
        </div>

        <div class="form-group">
          <label for>Add to Group:</label>
          <el-checkbox-group class="select-group-here" v-model="editContact.groups">
            <el-checkbox
              v-for="groupDetaillist in groupDetail"
              :key="groupDetaillist.id"
              :label="groupDetaillist.id"
            >{{ groupDetaillist.group_name }}</el-checkbox>
          </el-checkbox-group>
        </div>

        <div class="form-group">
          <label for>details:</label>
          <textarea class="form-control message-text" rows="3" v-model="editContact.details"></textarea>
        </div>
      </form>

      <span slot="footer" class="dialog-footer" left>
        <el-button @click="editContactdetails = false">Cancel</el-button>
        <el-button type="primary" @click="saveEditedContact()">Save</el-button>
      </span>
    </el-dialog>

    <!-- dialog for Custom Forms -->
    <el-dialog title="Custom Forms" :visible.sync="editcusform" width="50%">
      <div class="forms-tab">
        <div class="custom-tabs">
          <ul>
            <li
              :data-id="formslist.id"
              v-for="formslist in customform_lists"
              :key="formslist.id"
            >{{ formslist.form_name }}</li>
          </ul>
        </div>

        <div class="custom-forms-details">
          <el-form
            class="content-form"
            :label-position="'top'"
            label-width="100%"
            v-for="cusformdetail in customform"
            :key="cusformdetail.id"
          >
            <div v-for="cusforms in cusformdetail.Form" :key="cusforms.id">
              <el-form-item v-if="cusforms.selectedtype == 'input'" :label="cusforms.title">
                <el-input v-model="cusforms.answer" autofocus></el-input>
              </el-form-item>

              <el-form-item v-if="cusforms.selectedtype == 'textarea'" :label="cusforms.title">
                <el-input type="textarea" :rows="4" v-model="cusforms.answer" autofocus></el-input>
              </el-form-item>

              <el-form-item v-if="cusforms.selectedtype == 'radio'" :label="cusforms.title">
                <el-radio-group v-model="cusforms.answer">
                  <el-radio
                    v-for="radiooption in cusforms.option"
                    :key="radiooption.id"
                    :label="radiooption.opt"
                  ></el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item v-if="cusforms.selectedtype == 'checkbox'" :label="cusforms.title">
                <el-checkbox-group v-model="cusforms.answer">
                  <el-checkbox
                    v-for="checkboxoption in cusforms.option"
                    :key="checkboxoption.id"
                    :label="checkboxoption.opt"
                  ></el-checkbox>
                </el-checkbox-group>
              </el-form-item>

              <el-form-item v-if="cusforms.selectedtype == 'date'" :label="cusforms.title">
                <el-date-picker v-model="cusforms.answer" type="date"></el-date-picker>
              </el-form-item>

              <el-form-item v-if="cusforms.selectedtype == 'time'" :label="cusforms.title">
                <el-time-picker v-model="cusforms.answer"></el-time-picker>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer" left>
        <el-button @click="addNewChat = false">Cancel</el-button>
        <el-button type="primary" @click="saveformdetail()">Send</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import {
  getusergroups,
  editgenericuser,
  getgenericuser,
  addNewContact,
  convolistUrl,
  sendreplyUrl,
  getmessagesUrl,
  getHeader,
  getconvolistbydate
} from "./../../config";
import Vue from "vue";

export default {
  data() {
    return {
      filterStartDate: "",
      filterEndDate: "",
      unreadLeadNo: 0,
      currentPage: 0,
      totalPages: 0,
      isUnreadfilter: 0,

      loadingChatUsers: true,
      loadingChat: false,
      loadingEditContacts: true,

      pickerOptions: {
        shortcuts: [
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last 3 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value1: "",

      auto_message: [
        { message: "Thank you so much." },
        { message: "We will solve the problem ASAP." }
      ],

      editcusform: false,
      editContactdetails: false,
      addContactdetails: false,
      isnoChat: false,
      addnewContact: false,
      active_el: 0,
      search: "",

      newChatNumber: "",
      newChatMessage: "",

      addNewChat: false,
      datetime: new Date(),
      myNumber: JSON.parse(window.sessionStorage.getItem("mycontact")),
      page: 1,
      currentActiveId: "",
      currentActivename: "",
      groupDetail: [
        {
          id: "",
          group_name: "",
          group_description: ""
        }
      ],
      convoList: {
        convo_id: [],
        dateTime: "",
        name: "",
        unread: "",
        user_id: ""
      },
      convoChat: {
        client_user: "",
        unread: "",
        from_user: "",
        convo_id: "",
        to_user: "",
        datetime: "",
        msg: "",
        delivery_status: ""
      },
      sendReply: {
        sendmsg: ""
      },
      editContact: {
        id: "",
        name: "",
        code: "",
        number: "",
        groups: [],
        age: "",
        gender: "",
        details: ""
      },

      customform_lists: [
        { id: "1", form_name: "form 001" },
        { id: "2", form_name: "form 002" },
        { id: "3", form_name: "form 003" }
      ],

      customform: [
        {
          id: "1",
          form_name: "This is form name",
          Form: [
            {
              title: "This is input",
              selectedtype: "input",
              option: "",
              answer: ""
            },
            {
              title: "This is textarea",
              selectedtype: "textarea",
              option: "",
              answer: ""
            },
            {
              title: "This is radio",
              selectedtype: "radio",
              option: [{ opt: "radio1" }, { opt: "radio2" }],
              answer: ""
            },
            {
              title: "This is checkbox",
              selectedtype: "checkbox",
              option: [{ opt: "checkbox1" }, { opt: "checkbox2" }],
              answer: []
            },
            {
              title: "this is for date",
              selectedtype: "date",
              option: "",
              answer: ""
            },
            {
              title: "this is for time",
              selectedtype: "time",
              option: "",
              answer: ""
            }
          ]
        }
      ]
    };
  },

  methods: {
    startChange: function(e) {
      let date = new Date(e.sender._value);

      let year = date.getFullYear();
      let month = Number(date.getMonth()) + 1;
      let day = date.getDate();
      this.filterStartDate = year + "-" + month + "-" + day;
      console.log(this.filterStartDate);
    },
    endChange: function(e) {
      let date = new Date(e.sender._value);

      let year = date.getFullYear();
      let month = Number(date.getMonth()) + 1;
      let day = date.getDate();
      this.filterEndDate = year + "-" + month + "-" + day;
      console.log(this.filterEndDate);
    },
    onChange: function(currentRange) {
      console.log(this.currentRange);
    },

    getConvoListbyDate: function() {
      this.loadingChatUsers = true;
      axios
        .post(
          getconvolistbydate,
          {
            page: 1,
            from_date: this.filterStartDate,
            to_date: this.filterEndDate
          },
          { headers: getHeader() }
        )
        .then(response => {
          if (response.data.error == "false") {
            console.log(response.data);
            this.convoList = response.data.data;
            this.totalPages = response.data.page_count;
            this.currentPage = response.data.page_num;
            console.log("Total Pages :" + this.totalPages);
            console.log(response);
            this.loadingChatUsers = false;

            this.getUnreadCount();
          }
        });
    },

    getUnreadCount: function() {
      let n = [];

      n = this.convoList.filter(item => {
        return Number(item.unread) > 0;
      });
      this.unreadLeadNo = n.length;
      // return n;
    },

    prevPage: function() {
      let n = Number(this.currentPage) - 1;
      console.log("Loading Page : " + n);

      this.refreshConvoListApi(n);
    },

    nextPage: function() {
      let n = Number(this.currentPage) + 1;
      console.log("Loading Page : " + n);

      this.refreshConvoListApi(n);
    },
    markAsRead: function(pNumber) {
      console.log("Reading : " + pNumber);

      axios
        .post(
          getmessagesUrl,
          { page: 1, number: pNumber },
          { headers: getHeader() }
        )
        .then(response => {
          if (response.data.error == "false") {
            console.log("False");
            this.convoList = {};
            this.refreshConvoListApi(1);
          }
        });
    },

    getUnreadStatus: function(unreadCount) {
      if (unreadCount > 0) {
        return "unread";
      }
      return "read";
    },

    setsmsm() {
      this.sendReply.sendmsg = event.target.dataset.id;
    },

    refreshConvoListApi(pageNo) {
      axios
        .post(convolistUrl, { page: pageNo }, { headers: getHeader() })
        .then(Response => {
          this.convoList = Response.data.data;
          this.totalPages = Response.data.page_count;
          this.currentPage = Response.data.page_num;
          console.log("Total Pages :" + this.totalPages);
          console.log(Response);
          this.loadingChatUsers = false;

          this.getUnreadCount();
        });
    },
    scrollToEnd() {
      // const container = document.querySelector(".main-chatbox");
      // console.log(container);
      // const scrollHeightt = container.scrollHeightt;
      // console.log(scrollHeightt);
      // container.scrollTop = scrollHeightt;
    },

    changeChatUser: function(el) {
      this.loadingChat = true;
      var data_id = event.target.dataset.id;
      // console.log(data_id);
      this.currentActiveId = data_id;
      this.active_el = el;
      // console.log(this.active_el)

      axios
        .post(
          getmessagesUrl,
          { page: this.currentPage, number: this.currentActiveId },
          { headers: getHeader() }
        )
        .then(Response => {
          // console.log(Response);
          this.convoChat = Response.data.data.reverse();
          this.currentActivename = Response.data.name;
          this.$nextTick(function() {
            this.loadingChat = false;
            this.$nextTick(function() {
              this.scrollToEnd();
            });
          });
        });

      this.sendReply.sendmsg = "";
    },

    sendreplymsg() {
      axios
        .post(
          sendreplyUrl,
          {
            to_number: this.currentActiveId,
            from_number: this.myNumber,
            sms_text: this.sendReply.sendmsg
          },
          { headers: getHeader() }
        )
        .then(Response => {
          // console.log(Response);

          this.convoChat.push({
            unread: "0",
            convo_id: this.currentActivfpageeId,
            from_user: "1",
            to_user: this.currentActiveId,
            datetime: this.datetime,
            msg: this.sendReply.sendmsg,
            delivery_status: "0"
          });

          this.$nextTick(function() {
            this.scrollToEnd();
            this.sendReply.sendmsg = "";
          });
        });
    },

    createNewChat() {
      var current = this.newChatNumber;
      var valObj = this.convoList.filter(function(elem) {
        if (elem.convo_id == current) return elem.convo_id;
      });

      if (valObj.length > 0) {
        // console.log("contact exists yes")
        axios
          .post(
            sendreplyUrl,
            {
              to_number: this.newChatNumber,
              from_number: this.myNumber,
              sms_text: this.newChatMessage
            },
            { headers: getHeader() }
          )
          .then(Response => {
            // console.log(Response);

            this.refreshConvoListApi(1);

            this.isnoChat = false;
            this.active_el = Response.data.data.convo_id;
            this.currentActiveId = Response.data.data.convo_id;

            this.$nextTick(function() {
              axios
                .post(
                  getmessagesUrl,
                  { page: this.currentPage, number: this.currentActiveId },
                  { headers: getHeader() }
                )
                .then(Response => {
                  // console.log(Response);
                  this.convoChat = Response.data.data.reverse();
                  this.currentActivename = Response.data.name;
                  this.$nextTick(function() {
                    this.scrollToEnd();
                    this.newChatNumber = "";
                    this.newChatMessage = "";
                    this.sendReply.sendmsg = "";
                  });
                });
            });
          })
          .catch(function(error) {
            this.$notify({
              group: "foo",
              type: "error",
              title: "Error",
              text: "Something went wrong cant send message."
            });
          });
      } else {
        // console.log("contact exists no")
        axios
          .post(
            sendreplyUrl,
            {
              to_number: this.newChatNumber,
              from_number: this.myNumber,
              sms_text: this.newChatMessage
            },
            { headers: getHeader() }
          )
          .then(Response => {
            if (Response.data.error != "true") {
              // console.log("error sending message")
              // console.log(Response);

              this.refreshConvoListApi(1);

              // this.convoList.unshift({
              //     convo_id: this.newChatNumber,
              //     dateTime: this.datetime,
              //     name: null
              // })

              this.$nextTick(function() {
                this.isnoChat = false;
                this.active_el = Response.data.data.convo_id;
                this.currentActiveId = Response.data.data.convo_id;
              });

              this.$nextTick(function() {
                axios
                  .post(
                    getmessagesUrl,
                    { page: this.currentPage, number: this.currentActiveId },
                    { headers: getHeader() }
                  )
                  .then(Response => {
                    // console.log(Response);
                    this.convoChat = Response.data.data.reverse();
                    this.currentActivename = Response.data.name;
                    this.$nextTick(function() {
                      this.scrollToEnd();
                      this.newChatNumber = "";
                      this.newChatMessage = "";
                      this.sendReply.sendmsg = "";
                    });
                  });
              });
            } else {
              this.$notify({
                group: "foo",
                type: "error",
                title: "Error sending message",
                text: "Message or Number invalid"
              });
            }
          })
          .catch(function(error) {
            this.$notify({
              group: "foo",
              type: "error",
              title: "Error",
              text: "Something went wrong cant send message."
            });
          });
      }

      this.$nextTick(function() {
        this.addNewChat = false;
      });
    },

    resetEditContactForm() {
      this.editContact.id = "";
      this.editContact.name = "";
      this.editContact.number = "";
      this.editContact.age = "";
      this.editContact.gender = "";
      this.editContact.details = "";
      this.editContact.groups = [];
    },

    editcontactdetailsbtn() {
      // this.editContactdetails = true;
      this.loadingEditContacts = true;
      var clickedid = event.target.dataset.id;
      axios
        .post(getgenericuser, { user_id: clickedid }, { headers: getHeader() })
        .then(Response => {
          if (Response.data.error == "false") {
            this.loadingEditContacts = false;
            this.editContact = Response.data.data;
            this.editContactdetails = true;
          }
        });
    },

    saveEditedContact() {
      axios
        .patch(editgenericuser + this.editContact.id, this.editContact, {
          headers: getHeader()
        })
        .then(Response => {
          if (Response.data.error != "true") {
            this.refreshConvoListApi(1);
            this.active_el = this.currentActiveId;

            this.resetEditContactForm();

            this.$notify({
              group: "foo",
              type: "success",
              title: "Contact Saved",
              text: "Contact has been successfully added."
            });
          } else {
            this.$notify({
              group: "foo",
              type: "error",
              title: "Contact not Saved",
              text: "Contacts cant be saved"
            });
          }
          this.editContactdetails = false;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },

  mounted() {
    var start = $("#start").data("kendoDatePicker");
    var end = $("#end").data("kendoDatePicker");
    start.max(end.value());
    end.min(start.value());

    const run = this;
    this.refreshConvoListApi(1);

    this.$nextTick(function() {
      window.setInterval(() => {
        // this.sayhello()
        axios
          .post(
            getmessagesUrl,
            { page: this.currentPage, number: this.currentActiveId },
            { headers: getHeader() }
          )
          .then(Response => {
            // console.log(Response.data.unread);
            // this.convoChat = Response.data.data.reverse();
            if (Response.data.unread == 1) {
              // console.log("its 0");
              this.convoChat = Response.data.data.reverse();

              this.$nextTick(function() {
                this.scrollToEnd();
              });
            }
          })

          .catch(function(error) {
            console.log(error);
          });
      }, 10000);
    });

    axios.get(getusergroups, { headers: getHeader() }).then(Response => {
      // console.log(Response)
      this.groupDetail = Response.data.data;
    });
  },

  computed: {
    filteredChat: function() {
      return this.convoList.filter(allConvoList => {
        return allConvoList.convo_id.match(this.search);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.person-details {
  &.unread {
    background: #f2f2f2;
  }
}

.unread-btn-wrapper {
  float: right;
  position: absolute;
  top: 7px;
  right: 30px;
}

.filter-wrapper {
  margin-top: 90px;
  display: flex;
  flex: 1;
  justify-content: space-between;
  flex-wrap: wrap;
  .unreadFilter {
    display: inline-block;
    padding: 5px 5px;
    cursor: pointer;
    border: 2px solid #5058a0;
    border-radius: 8px;
    &.active {
      background: #5058a0;
      color: #fff;
      border-color: #5058a0;
    }
  }
}

.chatbox-content {
  display: flex;
  margin-top: 30px;
  .span {
    margin-left: 45px;
  }
}

.card-left-chatbox {
  margin-top: 0px;
  border: 0px;
}

.paginationbutton {
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  .nextPage {
    display: inline-block;
    margin-left: 5px;
    margin-right: 5px;
    padding: 5px 10px;
    cursor: pointer;
    border: 2px solid #5058a0;
    border-radius: 8px;

    &.active {
      background: #5058a0;
      color: #fff;
      border-color: #5058a0;
    }
  }
}

.nextp {
  margin-left: 20px;
  margin-right: 20px;
}

.span-flex {
  flex: 1;
  display: flex;
  justify-content: flex-start;
}
.span-image {
  display: flex;
  justify-content: center;
}

.iconpadding {
  flex: 1;
  display: flex;
  justify-content: center;
}

.el-icon-arrow-right {
  size: 20px;
}

.chatbox-persons {
  height: 100% !important;
  padding: 0 40px;
}

.datepickerbuttons {
  display: inline-block;
  margin-left: 10px;
  margin-right: 5px;
  padding: 5px 10px;
  cursor: pointer;
  background: #5058a0;
  border-radius: 8px;
  text-align: center;
  color: #ffffff;
}

.datepicker {
  display: inline-block;
  justify-content: center;
}

.dpheader {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 5px;
  margin-left: 5px;
  display: inline-block;
  justify-content: center;
  font-size: 12px;
  color: #5058a0;
}

.card-two {
  display: flex;
  flex: 1;
  justify-content: space-around;
}

.header-card {
  display: flex;
}
</style>


// WEBPACK FOOTER //
// src/components/views/manageleads.vue